// This is an autogenerated file. Do not manually edit.
// Run `node packages/controls/mini-fluent-icons-svg/updateIcons.js` to update the icons in this package
import * as React from 'react';
import CreateSvgIcon from '../components/CreateSvgIcon';
import { registerIcons } from '@uifabric/styling';

const PeopleRegular = CreateSvgIcon({
    Svg: props => (
        <svg {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM5.5 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm5 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-10 6.5C1.5 9.67 2.17 9 3 9h5c.83 0 1.5.67 1.5 1.5v.11a1.38 1.38 0 0 1-.01.14c0 .08-.03.2-.06.34-.07.27-.2.64-.46 1-.55.76-1.6 1.41-3.47 1.41-1.88 0-2.92-.65-3.47-1.4a2.85 2.85 0 0 1-.53-1.49v-.11Zm1 .09v.06l.04.2c.04.18.13.42.3.65.33.45 1.04 1 2.66 1s2.33-.55 2.66-1a1.85 1.85 0 0 0 .34-.9V10.5A.5.5 0 0 0 8 10H3a.5.5 0 0 0-.5.5v.09Zm9 1.91a4.1 4.1 0 0 1-1.46-.24c.19-.34.3-.67.36-.93.27.1.63.17 1.1.17 1.12 0 1.58-.38 1.78-.67a1.22 1.22 0 0 0 .22-.56v-.02a.25.25 0 0 0-.25-.25h-2.8c-.07-.37-.23-.7-.45-1h3.25c.69 0 1.25.56 1.25 1.25v.02a1.35 1.35 0 0 1 0 .1l-.05.27c-.05.21-.15.5-.36.78-.42.59-1.2 1.08-2.59 1.08Z" />
        </svg>
    ),
    displayName: 'PeopleRegular',
});

export default 'PeopleRegular';

registerIcons({
    icons: {
        PeopleRegular: <PeopleRegular />,
    },
});
